/* eslint-disable */
export enum BenefitTypeEnum {
  MEAL_BENEFIT = "meal-benefit",
  TRANSPORT_BENEFIT = "transport-benefit",
  NURSERY_BENEFIT = "nursery-benefit",
  EDUCATION_BENEFIT = "education-benefit",
  GYM_BENEFIT = "gym-benefit",
  HEALTH_INSURANCE_BENEFIT = "health-insurance-benefit",
  GIFT_CARD_BENEFIT = "gift-card-benefit",
  RENTING_BENEFIT = "renting-benefit",
  LIFE_INSURANCE_BENEFIT = "life-insurance-benefit",
  WELLNESS_BENEFIT = "wellness-benefit",
  UNKNOWN = "unknown",
  RETIREMENT_INSURANCE_BENEFIT = "retirement-insurance-benefit",
  PENSION_PLAN_BENEFIT = "pension-plan-benefit",
  IT_PRODUCT_BENEFIT = "it-product",
  CUSTOM_BENEFIT = "custom",
  CLAPS = "claps",
}

export type BenefitType =
  | "meal-benefit"
  | "transport-benefit"
  | "nursery-benefit"
  | "education-benefit"
  | "gym-benefit"
  | "health-insurance-benefit"
  | "gift-card-benefit"
  | "renting-benefit"
  | "life-insurance-benefit"
  | "wellness-benefit"
  | "it-product"
  | "custom"
  | "unknown";
